import { render, staticRenderFns } from "./Dashboard-new.vue?vue&type=template&id=0b5ed00c&scoped=true"
import script from "./Dashboard-new.vue?vue&type=script&lang=ts"
export * from "./Dashboard-new.vue?vue&type=script&lang=ts"
import style0 from "./Dashboard-new.vue?vue&type=style&index=0&id=0b5ed00c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5ed00c",
  null
  
)

export default component.exports